import { useState } from "react";
import DestinationGrid from "../components/destinations/DestinationGrid";
import DestinationsFilters from "../components/destinations/DestinationsFilters";
import { destinations } from "../components/destinations/destinations.data";
import Section from "../components/ui/Section";

import "../styles/destinations.scss";

export default function Destinations() {
  const [search, setSearch] = useState("");
  const [region, setRegion] = useState("");
  const [tag, setTag] = useState("");

  const filteredDestinations = destinations.filter((destination) => {
    const matchesSearch = destination.title
      .toLowerCase()
      .includes(search.toLowerCase());

    const matchesRegion = !region || destination.region === region;

    const matchesTag = !tag || destination.tags?.includes(tag);

    return matchesSearch && matchesRegion && matchesTag;
  });

  return (
    <main className="destinations-page">
      <Section
        title="Journeys"
        subtitle="Road stories from quiet routes, detours, and unexpected stops."
      >
        {/* Filters */}
        <DestinationsFilters
          search={search}
          setSearch={setSearch}
          region={region}
          setRegion={setRegion}
          tag={tag}
          setTag={setTag}
        />

        {/* Grid */}
        <DestinationGrid destinations={filteredDestinations} />
      </Section>
    </main>
  );
}
